<template>
  <div  id="app">
    <div v-if="hasCode && goodCode">
      <mobile-version v-if="isMobile"/>
      <home-desktop v-else/>
    </div>
    <div v-else class="default-wrapper">
      <router-view/>
    </div>
  </div>
</template>

<script>
import MobileVersion from "./components/Responsive";
import HomeDesktop from "./components/HomeDesktop";
import httpcli from "axios";
import Utils from '@/utils'

export default {
  name: "app",
  data: function() {
    return {
      hasCode: false,
      isMobile: false,
      goodCode: false
    }
  },
  components: {
    HomeDesktop,
    MobileVersion
  },

  beforeMount () {
    this.isMobile = document.body.clientWidth <= 640
  },

  mounted: function () {
    let code = this.$route.params.code
    if (code) {
      this.hasCode = true
    }
     const infosgetter = httpcli.create({
        baseURL: endpoint,
        headers: {
            'Content-Type': 'application/json',
            'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
        }
        });
    infosgetter.get(`/rdv/code/${code}`)
    .then( (response) => {
      let d = response.data.data.data
        Utils.showConsoleLog({
          object: 'from App.vue M',
          variableToLog: d
        })
      if (response.status === 200) {
        this.goodCode = true
      }
      else {
        this.goodCode = false
        this.$router.push({name: 'badCode'})
      }
    })
    .catch((error)=>{
      console.error('error from App', error)
      this.$router.push({name: 'default'})
    })

    window.addEventListener('resize', () => {
      this.isMobile = document.body.clientWidth <= 640
    })
  }
};
</script>

<style>
/* Gobal styles */
#app {
  font-family: "Muli", sans-serif;
  text-align: center;
  color: #808080;
  padding: 0;
  display: flex;
  flex-direction: row;
}
body {
  box-sizing: border-box;
  margin: 0;
  font-size: 1em;
  letter-spacing: 0.0625em;
}
.default-wrapper {
  width: 100%;
  height: 100vh;
}
@media all and (max-width: 600px) {
  body {
    font-size: 0.74rem;
    background: #f9fcfd;
  }
}
</style>
